module.exports = __webpack_public_path__ + "img/213.2a8191eb.png";